import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDatas } from '../../../../services/axiosInstanceService';
import { adDpesApiToStoreParser } from '../../adParser';

interface IFetchAdDpeLocationsThunkProps {
  minBuiltArea: number;
  maxBuiltArea: number;
  dpe?: string;
  ges?: string;
  dpeStartDate: string;
  dpeEndDate: string;
  propertyTypology: string;
  inseeCode: string;
}
const fetchAdDpeLocationsThunk = createAsyncThunk(
  'ad/fetchAdDpeLocationsThunk',
  async (params: IFetchAdDpeLocationsThunkProps) => {
    try {
      const {
        minBuiltArea,
        maxBuiltArea,
        dpe,
        ges,
        dpeStartDate,
        dpeEndDate,
        propertyTypology,
        inseeCode,
      } = params;
      if (!inseeCode) throw new Error('No insee code found');

      const requestParams: Record<string, any> = {
        min_built_area: minBuiltArea,
        max_built_area: maxBuiltArea,
        dpe_start_date: dpeStartDate,
        dpe_end_date: dpeEndDate,
        property_typology: propertyTypology,
      };

      // Only include dpe and ges if they have values
      if (dpe) requestParams.dpe = dpe;
      if (ges) requestParams.ges = ges;

      const response = await fetchDatas(
        `/parcels/${inseeCode}/result_by_energy_ranking`,
        requestParams,
      );

      const parsed = adDpesApiToStoreParser(response['hydra:member']);

      return parsed;
    } catch (error) {
      return Promise.reject(error);
    }
  },
);

export default fetchAdDpeLocationsThunk;
